module.exports = __webpack_public_path__ + "img/Team-KennethTennyson.1f83b088.png";